<template>
    <b-container fluid>
        <validation-observer ref="observer" v-slot="{ invalid }">
            <b-form @submit.prevent="onSubmit">
                <b-card>
                    <b-card-header>
                       <h3>{{ title }}</h3>
                    </b-card-header>
                    <b-card-body>
                        <b-form-group :label="$t('posUser.tax-number')" label-cols="2"
                                      :description="$t('posUser.tax-number-tooltip')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <b-form-input style="width:50%;" v-model="user.taxNumber" :disabled="editMode"/>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group :label="$t('posUser.name')" label-cols="2"
                                      :description="$t('posUser.name-tooltip')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <b-form-input style="width:50%;" v-model="user.name"/>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group :label="$t('posUser.cash-deposit-iban')" label-cols="2"
                                      :description="$t('posUser.cash-deposit-iban-tooltip')">
                            <validation-provider rules="required" v-slot="{ errors }">
                                <b-form-input style="width:50%;" v-model="user.cashDepositIban"/>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group :label="$t('posUser.scan-qr-upn-enabled')" label-cols="2"
                                      :description="$t('posUser.scan-qr-upn-enabled-tooltip')">
                            <p-checkbox class="col-sm-offset-1" v-model="user.scanQrUpnEnabled">{{ $t('posUser.scan-qr-upn-enabled-checkbox') }}</p-checkbox>
                        </b-form-group>

                        <b-form-group :label="$t('posUser.manual-qr-upn-enabled')" label-cols="2"
                                      :description="$t('posUser.manual-qr-upn-enabled-tooltip')">
                            <p-checkbox class="col-sm-offset-1" v-model="user.manualQrUpnEnabled">{{ $t('posUser.manual-qr-upn-enabled-checkbox') }}</p-checkbox>
                        </b-form-group>
                    </b-card-body>
                    <b-card-footer>
                        <b-button type="button" @click="cancelUpdate" v-if="editMode">{{ $t('posUser.cancel-button')}}</b-button>
                        <b-button type="submit" class="btn btn-fill btn-info" :disabled="invalid">{{ $t('posUser.save-button')}}</b-button>
                    </b-card-footer>
                </b-card>
            </b-form>
        </validation-observer>
    </b-container>
</template>

<script>
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import i18n from "../i18n";
    import { required } from 'vee-validate/dist/rules';
    import swal from 'sweetalert2'

    extend('required', {
        ...required,
        message: (_, values) => i18n.t('posUser.required', values)
    });

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        name: "UserForm",
        props: {
            user: {
                type: Object,
                default() {
                    return {
                        taxNumber: null,
                        name: null,
                        cashDepositIban: null
                    }
                }
            },
            editMode: {
                default: false
            },
            title: {
                default: ''
            }
        },
        methods: {
            onSubmit(evt){
                evt.preventDefault()
                this.updateProfile()
            },
            updateProfile() {
                let request = {
                    user: this.user
                };

                let path = 'addUser';
                if(this.editMode) {
                    path = "modifyUser";
                }

                this.$store.dispatch(path, request)
                    .then(() => {
                        let message = this.$t('userList.add-success');
                        if(this.editMode) {
                            message = this.$t('userList.update-success');
                        }

                        swal.fire({
                            title: this.$t('userList.info-title'),
                            text:message,
                            confirmButtonClass: 'btn btn-success btn-fill',
                            icon: 'success'
                        }).then(() => {
                            this.clearForm();

                            if(this.editMode) {
                                this.$modal.hide('edit-user', {updated: true });
                            } else {
                                this.$router.push('/list');
                            }
                        })
                    })
                    .catch(error => {
                        // TODO FIXME XXX: Move to global error handling!
                        if(typeof (error.data) !== 'undefined' && typeof (error.data.message) !== 'undefined' && error.data.message.includes('A137')) {
                            this.$store.commit('setError', this.$t('addUser.agent-id-exists-error'));
                        } else {
                            this.$store.commit('setError', error);
                        }
                    });
            },
            cancelUpdate() {
                this.clearForm();
                if(this.editMode) {
                    this.$modal.hide('edit-user');
                }
            },
            clearForm() {
                this.user.taxNumber = null;
                this.user.name = null;
                this.user.cashDepositIban = null;
            }
        },
        activated() {
            if(!this.editMode) {
                this.clearForm();
            }
        }
    }
</script>

<style scoped>

</style>